<template>
  <div>
    <ChartCard>
      <ChartHeader
        label="Is the demographic survey reaching candidates from all intended sources?"
        tooltip-key="demo-survey-source-table"
      >
        <template #download>
          <FillRateCSVDownload
            class="ml-2"
            is-source-table
          />
        </template>
      </ChartHeader>
      <div class="w-100 d-flex flex-column">
        <div
          v-for="({ source_category, fill_rate, sources }) in sortedSourceCategories"
          :key="source_category"
          class="w-100 d-flex flex-column source-category"
        >
          <SourceCategory
            :open-category="sourceOpenCategory"
            :source-category="source_category"
            :fill-rate="fill_rate"
            :sources="sources"
            @update:open-category="handleSourceCategoryClick"
          />
          <div
            v-if="sourceOpenCategory === source_category"
            class="child-sources-container w-100 d-flex flex-column"
          >
            <Source
              v-for="({
                ats_source_label,
                fill_rate: sourceSurveySubmitted,
                total: sourceTotalApps,
              }) in sources"
              :key="ats_source_label"
              :ats-source-label="ats_source_label"
              :fill-rate="sourceSurveySubmitted"
              :total-applications="sourceTotalApps"
            />
          </div>
        </div>
      </div>
    </ChartCard>
  </div>
</template>

<script setup>
import ChartCard from '@/components/insights/Chart/ChartCard.vue';
import ChartHeader from '@/components/insights/Chart/ChartHeader.vue';
import { useDemographicSurveyReport } from '@/stores/insights/demographicSurveyReport';
import { storeToRefs } from 'pinia';
import SourceCategory from '@/components/insights/ProcessInsights/DemographicSurveyReport/tables/SourceCategory.vue';
import Source from '@/components/insights/ProcessInsights/DemographicSurveyReport/tables/Source.vue';
import FillRateCSVDownload from '@/components/insights/ProcessInsights/DemographicSurveyReport/tables/FillRateCSVDownload.vue';
import { useTracking } from '@/stores/tracking/tracking';

const { sortedSourceCategories, sourceOpenCategory } = storeToRefs(useDemographicSurveyReport());

const { updateSourceOpenCategory } = useDemographicSurveyReport();

const handleSourceCategoryClick = (sourceCategory) => {
  useTracking().track({
    name: 'Expanded Source Category Row on Demographic-survey-report page',
    params: {
      source_category: sourceCategory,
    },
  });

  updateSourceOpenCategory(sourceCategory === sourceOpenCategory.value
    ? null
    : sourceCategory);
};

</script>

<style lang="less" scoped>
.source-fill-rate-table {
  min-height: 293px;
}

.source-category:not(:last-child) {
  border-bottom: 1px solid @stroke-default;
}

.child-sources-container {
  max-height: 205px;
  overflow-y: auto;
}
</style>
